import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Dialog, Flex, List, Markdown, Text } from '@applyboard/crystal-ui';
import { CheckCircleOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { useQueryParams } from "../../../../data";
import { useApplicationStudent, useApplicationMainProgram, useApplicationPaymentInformation, useLegacyApplication } from "../../data";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ApplicationCreatedDialog = function ApplicationCreatedDialog() {
  var _student$profile, _student$profile$pers, _student$profile2, _student$profile2$per;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useQueryParams = useQueryParams(),
    queryParams = _useQueryParams.queryParams;
  var history = useHistory();
  var _useApplicationStuden = useApplicationStudent(),
    student = _useApplicationStuden.student;
  var _useApplicationMainPr = useApplicationMainProgram(),
    mainProgramDetails = _useApplicationMainPr.mainProgramDetails;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useApplicationPaymen = useApplicationPaymentInformation(),
    applicationPaymentInformation = _useApplicationPaymen.applicationPaymentInformation;
  var _useTranslation = useTranslation('ApplicationCreatedDialog'),
    t = _useTranslation.t;
  var hasOutstandingPrepaymentRequirements = legacyApplication.meta.outstandingPrePaymentRequirements;
  var isEvaluationPending = legacyApplication.meta.requirementsEvaluationStatus === 'pending';
  var showPaymentRequiredInstructions = (applicationPaymentInformation === null || applicationPaymentInformation === void 0 ? void 0 : applicationPaymentInformation.requiresPayment) && !isEvaluationPending;
  var _useEventTracker = useEventTracker({
      data: {
        outStandingRequirements: hasOutstandingPrepaymentRequirements ? 'This application has outstanding requirements' : 'No outstanding requirements',
        requirements_evaluation_status: isEvaluationPending ? 'Evaluation status still pending' : 'Evaluation status is not pending'
      }
    }),
    trackEvent = _useEventTracker.trackEvent;

  // eslint-disable-next-line -- This useEffect is needed to handle URL parameter changes
  useEffect(function () {
    if (queryParams.has('application_created')) {
      var newParams = new URLSearchParams(queryParams);
      newParams["delete"]('application_created');
      history.replace({
        search: newParams.toString()
      });
      setIsOpen(true);
    }
  }, [queryParams, history]);
  return _jsxs(Dialog, {
    onOpenChange: function onOpenChange(dialogState) {
      setIsOpen(dialogState);
      if (!dialogState) {
        trackEvent({
          event: 'Single Application V2 - Creation - Success Message Dismissed'
        });
      }
    },
    open: isOpen,
    size: "md",
    children: [_jsx(Dialog.Heading, {
      children: t('heading')
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        direction: "row",
        gap: 4,
        children: [_jsx(Flex.Item, {
          children: _jsx(CheckCircleOutlineIcon, {
            intent: "positive",
            size: "xl"
          })
        }), _jsxs(Flex, {
          direction: "column",
          children: [_jsxs(Flex, {
            direction: "column",
            gap: 4,
            children: [_jsx(Markdown, {
              headingSettings: {
                baseLevel: 3
              },
              markdown: t('successMessage', {
                studentName: "".concat(student === null || student === void 0 ? void 0 : (_student$profile = student.profile) === null || _student$profile === void 0 ? void 0 : (_student$profile$pers = _student$profile.personalInformation) === null || _student$profile$pers === void 0 ? void 0 : _student$profile$pers.firstName, " ").concat(student === null || student === void 0 ? void 0 : (_student$profile2 = student.profile) === null || _student$profile2 === void 0 ? void 0 : (_student$profile2$per = _student$profile2.personalInformation) === null || _student$profile2$per === void 0 ? void 0 : _student$profile2$per.lastName),
                programName: mainProgramDetails === null || mainProgramDetails === void 0 ? void 0 : mainProgramDetails.name
              })
            }), !showPaymentRequiredInstructions && _jsx(Text, {
              as: "p",
              children: t('noPaymentRequiredMessage')
            }), showPaymentRequiredInstructions && _jsx(Text, {
              as: "p",
              children: t('instructionsMessage')
            })]
          }), showPaymentRequiredInstructions && _jsx(Box, {
            py: 4,
            children: _jsxs(List, {
              ordered: true,
              children: [hasOutstandingPrepaymentRequirements && _jsx(List.Item, {
                children: t('steps.prePaymentRequirements')
              }, "pre-payment"), _jsx(List.Item, {
                children: t('steps.payment')
              }, "payment"), _jsx(List.Item, {
                children: t('steps.postPaymentRequirements')
              }, "post-payment")]
            })
          })]
        })]
      })
    }), _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        intent: "primary",
        onClick: function onClick() {
          setIsOpen(false);
          trackEvent({
            event: 'Single Application V2 - Creation - Success Message Dismissed'
          });
        },
        width: "fill",
        children: t('okButton')
      })
    })]
  });
};